<template>
  <vue-scroll>
    <el-upload
      class="upload-demo"
      action="https://apicloud.magycorp.com:48028/api/gallery/ComparationGpsLines"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-success="handleUploadSuccess"
      multiple
      :limit="1"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <el-button size="small" type="primary">Gargar Excel</el-button>
      <div slot="tip" class="el-upload__tip">
        Excel Con tamaño menor a 500kb
      </div>
    </el-upload>

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />
  </vue-scroll>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import RenderCheckLabelRequired from "@/components/functionals/RenderCheckLabelRequired.vue";

export default {
  name: "ComparationLinesGps",
  components: {
    RabbeyTable3
  },
  data() {
    return {
      columns: [
        {
          prop: "CodeCliente",
          label: "User Id",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "TrakerId",
          label: "No. Gps",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "Cliente",
          label: "Cliente",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "Telefono",
          label: "Numero de telefono",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "IsOnNavixy",
          label: "Existe en Navixy",
          fixed: true,
          minWidth: 200,
          sortable: true,
          formatter: RenderCheckLabelRequired
        }
      ],
      items: [],
      fileList: []
    };
  },
  methods: {
    handleUploadSuccess(response) {
      this.items = response;
    },
    handleRemove() {
      this.items = [];
    },
    handleExceed(files) {
      this.$message.warning(
        `Tienes un limite de solo un archivo${files.length}`
      );
    },
    beforeRemove(file) {
      return this.$confirm(
        `Seguro que quiere borrar el archivo ${file.name} ? Los datos en el reporte se van a borrar..`
      );
    }
  }
};
</script>
